import React from 'react';
import BenchFront from "./BenchFront"

export default function StoolFront(props) {
    return BenchFront(props)
}